import * as React from 'react'
import {Dialog, DialogContent, IconButton, useMediaQuery} from '@mui/material'
import withStyles from '@mui/styles/withStyles'
import {Close} from '@mui/icons-material'
import {BreakPoint} from '../../../../../styledComponents/Constants'
import styled from 'styled-components'
import ImageGallery from 'react-image-gallery'
import {currentMedia} from '../../../../../styledComponents/ResponsiveConvenience'
import {ArrowIcon} from '../../../../common/icons/NatSvgIcon'

interface ImagesProps {
    open: boolean
    src: {
        original: string,
        srcSet?: string,
        sizes?: string
    }[]
    onClose: () => void
    startIndex: number
}

export const ImageViewDialog: React.FC<ImagesProps> = props => {
    const {src} = props
    const matches = useMediaQuery(`(min-width: ${BreakPoint.Sp})`)

    return (
        <StyledDialog
            fullScreen={!matches}
            open={props.open}
            maxWidth={false}
        >
            <CloseButton
                aria-label={'close'}
                onClick={props.onClose}
            >
                <CloseIcon/>
            </CloseButton>
            <DialogContent style={{padding: 0}}>
                <StyledGalleryWrapper>
                    <ImageGallery
                        items={src}
                        startIndex={props.startIndex}
                        showPlayButton={false}
                        showFullscreenButton={false}
                        showThumbnails={false}
                        showBullets={false}
                        infinite={false}
                        renderLeftNav={(onClick, disabled) => {
                            if (disabled) return <></>
                            return (
                                <NavButtonBefore
                                    onClick={onClick}
                                >
                                    <ArrowBackIosIcon/>
                                </NavButtonBefore>
                            )
                        }}
                        renderRightNav={(onClick, disabled) => {
                            if (disabled) return <></>
                            return (
                                <NavButtonNext
                                    onClick={onClick}
                                >
                                    <ArrowForwardIcon/>
                                </NavButtonNext>
                            )
                        }}
                    />
                </StyledGalleryWrapper>
            </DialogContent>
        </StyledDialog>
    )
}

const CloseButton = styled(IconButton)`
    &.MuiButtonBase-root {
        position: absolute;
        padding: 0;
        right: 20px;
        top: 20px;
        color: #FFFFFF;
        ${currentMedia.lessThan('sp')`
            right: 10px;
            top: 10px;
        `}
    }
`

const CloseIcon = withStyles({
    root: {
        stroke: 'white',
        strokeWidth: 0.5,
        zIndex: 1,
        fontSize: 24
    }
})(Close)

const StyledDialog = styled(Dialog)`
    & .MuiDialog-paper {
        width: 100%;
        max-width: 900px;
        height: 100%;
        max-height: 790px;
        ${currentMedia.lessThan('sp')`
            max-width: 100%;
            max-height: 100%;
            margin: 0;
        `}
        background-color: #000000;
        overflow: hidden;
        position: relative;
    }
`

const StyledGalleryWrapper = styled.div`
    width: 100%;
    height: 100%;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;

    padding: 45px 100px;
    ${currentMedia.lessThan('sp')`
        padding: 50px 30px;
    `}
    box-sizing: border-box;

    & .image-gallery,
    & .image-gallery-content,
    & .image-gallery-swipe,
    & .image-gallery-slide,
    & .image-gallery-slides {
        width: 100%;
        height: 100%;
    }

    & .image-gallery,
    & .image-gallery-content,
    & .image-gallery-slide-wrapper {
        position: initial;
        width: 100%;
        height: 100%;
    }

    & .image-gallery-image {
        width: 100% !important;
        height: 100% !important;
        object-fit: scale-down !important;
        background-color: #000000 !important;
    }
`

const NavButtonNext = styled(IconButton)`
    &.MuiButtonBase-root {
        position: absolute;
        top: 50%;
        right: 35px;
        transform: translateY(-50%);
        z-index: 10;
        color: #FFFFFF;
        padding: 0;
        ${currentMedia.lessThan('sp')`
            right: 9px;
        `}
    }
`

const NavButtonBefore = styled(IconButton)`
    &.MuiButtonBase-root {
        position: absolute;
        top: 50%;
        left: 35px;
        transform: translateY(-50%);
        z-index: 10;
        color: #FFFFFF;
        padding: 0;
        ${currentMedia.lessThan('sp')`
            left: 9px;
        `}
    }
`

const ArrowBackIosIcon = styled(ArrowIcon)`
    width: 30px;
    height: 60px;
    transform: rotate(180deg);
    ${currentMedia.lessThan('sp')`
        width: 12px;
        height: 24px;
    `}
`

const ArrowForwardIcon = styled(ArrowIcon)`
    width: 30px;
    height: 60px;
    ${currentMedia.lessThan('sp')`
        width: 12px;
        height: 24px;
    `}
`